// extracted by css-extract-rspack-plugin
export default {"Box":"BlobTopBanners-module__Box__v_nvx"};